import { Link } from "react-router-dom";

export default function ErrorBoundaryFallback({ error, resetError }) {
  return (
    <div className="min-h-screen grid place-items-center bg-slate-50 px-4">
      <div className="max-w-md rounded-lg border border-rose-200 bg-white p-8 shadow-sm">
        <div className="text-xs font-semibold uppercase tracking-widest text-rose-700">Something broke</div>
        <h1 className="mt-2 font-heading text-2xl font-bold tracking-tight text-slate-900">The page hit an unexpected error.</h1>
        <p className="mt-3 text-sm text-slate-500">We logged it. Try reloading or head back to your dashboard. If it keeps happening, email support with the URL and the message below.</p>
        {error?.message && (
          <pre className="mt-4 rounded-md bg-slate-100 p-3 text-[11px] font-mono text-slate-700 overflow-auto max-h-32">{error.message}</pre>
        )}
        <div className="mt-6 flex items-center gap-3">
          <button onClick={() => (resetError ? resetError() : window.location.reload())} className="rounded-md px-4 py-2 text-sm font-semibold text-white" style={{ background: "var(--primary-hex, #1F6FEB)" }} data-testid="error-reload">Reload page</button>
          <Link to="/" className="text-sm text-slate-600 hover:text-slate-900">Home</Link>
        </div>
      </div>
    </div>
  );
}
